// Copyright (c) Microsoft Corporation. All rights reserved.

import { MeetingType, PreMeetingType } from "./WeGoHostedProps";
import React, { Component } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { WegoContext, WegoContextType } from "../misc/WegoContext";

import Constants from "../misc/WegoConstants";
import WegoAuthUser from "../auth/WegoAuthUser";
import WegoBrowserAuthService from "../auth/WegoBrowserAuthService";
import WegoConfiguaration from "../WegoConfiguration";
import WegoConstants from "../misc/WegoConstants";

interface WegoBrowserHostProps extends RouteComponentProps {
  appId: string;
  appName: string;
  appMeetingType: MeetingType;
  appPreMeetingType: PreMeetingType;
  wegoConfiguration: WegoConfiguaration;
}

type WegoBrowserHostState = {
  isLoggedIn?: boolean;
  showInSurface: string;

  wegoContext: WegoContextType | null;
}

type WegoBrowserHostQueryParams = {
  meeting: string;
}


class WegoBrowserHost extends Component<WegoBrowserHostProps, WegoBrowserHostState> {
  private authService: React.RefObject<WegoBrowserAuthService>
  private meetingId?: string;
  state: WegoBrowserHostState;

  constructor(props: WegoBrowserHostProps) {
    super(props);
    this.authService = React.createRef();

    this.state = {
      showInSurface: WegoConstants.Surfaces.Stage,
      wegoContext: null
    }
  }

  componentDidMount() {
    let queryPath = this.props.match.params as WegoBrowserHostQueryParams;
    this.meetingId = queryPath.meeting !== undefined ? queryPath.meeting : this.props.wegoConfiguration.debugBrowserMeetingId!;

    this.authService.current?.determineLoginStatus(); // Triggers onLoggedIn or onNotLoggedIn to be called back.
  }

  onLoggedIn() {
    this.authService.current?.getUser().then((user: WegoAuthUser) => {
      let wegoContext = this.setupContext(user);
      this.setState({
        isLoggedIn: true,
        wegoContext: wegoContext
      });
    });
  }

  onNotLoggedIn() {
    // Remember where we were so we can get back here after auth end.
    localStorage.setItem(Constants.Auth.UrlAfterRedirectKey, this.props.location.pathname);
    this.authService.current!.login().then(() => this.setState({ isLoggedIn: false }));
  }

  setupContext(user: WegoAuthUser): WegoContextType {
    return {
      tenantId: this.props.wegoConfiguration.debugBrowserTenantId!,
      appId: this.props.appId,
      meetingId: this.meetingId!,
      userId: user.userId,
      userPrincipalName: user.userPrincipalName,
      teamsMode: false,
      teamsTheme: undefined,
      teamsFrameContext: undefined,
      configuration: this.props.wegoConfiguration
    }
  }

  render() {
    const MeetingAppComponent = this.props.appMeetingType;
    return (
      <WegoContext.Provider value={this.state.wegoContext}>
        <div style={{ backgroundColor: "black" }}>
          <WegoBrowserAuthService
            ref={this.authService}
            wegoConfiguration={this.props.wegoConfiguration}
            onLoggedIn={() => this.onLoggedIn()}
            onNotLoggedIn={() => this.onNotLoggedIn()}
          />

          {this.state.isLoggedIn === true && this.state.showInSurface !== WegoConstants.Surfaces.PreMeeting &&
            <MeetingAppComponent
              surface={this.state.showInSurface}
              appId={this.state.wegoContext?.appId!}
              userId={this.state.wegoContext?.userId!}
              userPrincipalName={this.state.wegoContext?.userPrincipalName!}
              meetingId={this.state.wegoContext?.meetingId!}
            />
          }

          {this.state.isLoggedIn === true && this.state.showInSurface === WegoConstants.Surfaces.PreMeeting &&
            <div className="App ms-Fabric">
              <this.props.appPreMeetingType
                appId={this.props.appId}
                appName={this.props.appName}
                meetingId={this.state.wegoContext!.meetingId}
                userPrincipalName={this.state.wegoContext!.userPrincipalName}
              />
            </div>
          }
        </div>
      </WegoContext.Provider>
    );
  }
}

export default withRouter(WegoBrowserHost);